var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHonduras(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1093.3 490.92c-47.762 20.039-92.52 39.602-138.12 57.48-20.039 7.9219-38.52 7.4414-55.801-12.359-18.961-21.84-53.16-20.52-74.762 1.6797-13.559 13.922-23.398 31.801-33.121 48.961-24.121 42.359-38.762 92.641-94.441 106.8-1.5586-0.83984-3.7188-1.1992-4.5586-2.3984-31.68-43.078-47.16-44.039-81.84-3.2383-13.199 15.48-24.602 24.359-48.238 17.641-32.398-9.2383-55.32 14.52-51.961 48.238 2.0391 20.879 5.8789 41.398-20.879 51.602-7.1992 2.7617-9.9609 15.719-16.441 22.441-7.0781 7.1992-16.078 16.922-24.48 17.16-8.3984 0.23828-19.559-8.1602-24.961-15.961-17.398-25.199-31.078-54.359-71.52-46.559 0-18.84 0.60156-36.84-0.12109-54.602-1.0781-23.879-8.6406-46.801-33.121-54.238-27.84-8.3984-57.238-15.359-84.602 5.6406-5.7617 4.4414-18.961 7.3203-23.52 3.9609-19.559-14.762-37.199-31.922-55.32-48.359-19.68-17.879-39-36.121-54.121-50.16 0-26.879-2.1602-52.32 0.96094-77.281 1.4414-11.641 11.52-29.762 20.281-31.559 57.238-11.281 95.398-50.398 137.76-85.078 19.922-16.32 46.68-24.48 70.922-35.16 4.0781-1.8008 11.281 2.8789 16.801 5.1602 79.559 32.039 157.8 40.32 238.92 0.12109 23.762-11.762 56.879-6 85.801-6.3594 28.32-0.35938 58.68 8.3984 84.84 1.3203 66.961-18.121 129.24-3.8398 187.08 24.719 46.922 23.16 87.84 58.199 131.04 88.68 6 4.1992 9.7188 11.641 17.762 21.84z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHonduras);
export default __webpack_public_path__ + "static/media/honduras.637555abac7ed3d8d729ab5bc6b2a4db.svg";
export { ForwardRef as ReactComponent };